import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { GenerateUUIDv4 } from '../../../shared/utils/uuid.utils';

@Component({
  selector: 'app-configuration-create-application-form',
  templateUrl: '../templates/configurationCreateApplicationForm.component.html',
})
@Injectable()
export class ConfigurationCreateApplicationFormComponent {
  @Input() Application;

  @Output() OnSubmit = new EventEmitter<{ isSuccess: boolean, data?: any }>();

  constructor(private configurationService: ConfigurationService, private alertService: AlertService) { }

  SaveApplication() {
    this.alertService.removeAll();

    if (!this.isValidApplication()) {
      return;
    }

    this.configurationService.CreateApplication(this.Application)
      .subscribe(
        () => this.OnSubmit.emit({ isSuccess: true }),
          err => this.OnSubmit.emit({ isSuccess: false, data: err })
      );
  }

  NewId() {
    const guid = GenerateUUIDv4();
    this.Application.Id = guid;
  }

  private isValidApplication() {
    const isValid = this.Application && this.Application.Id && this.Application.Name;
    return isValid;
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/configurationCreateApplicationForm.component.ts